// import { Table, Space } from 'antd';
// import React from 'react';
import Main from "../components/layout/Main";
import Header from "../components/layout/Header";
// import { useHistory } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftOutlined, BarChartOutlined, DashboardTwoTone, DashboardOutlined, BranchesOutlined } from "@ant-design/icons";
import { useEffect } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Button, Input, Space, Table, Badge, Modal, Checkbox, Tag, Spin } from 'antd';
import React, { useRef, useState } from 'react';
import Highlighter from 'react-highlight-words';
import { get, post } from "../Libraries/Ajax/HttpService";
import Img1 from '../assets/images/img1.png';
import Meter from '../assets/images/meter.png';
import Tank from '../assets/images/tank.png';
import GPWell from '../assets/images/gpwell.png';
import WaterPlants from '../assets/images/water-plants.png';
import WaterMeter from '../assets/images/water-meter.png';
import LeftArrow from '../assets/images/left-arrow.svg';
import round from '../assets/images/round.svg';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const Schematics = () => {
    const [usage, setUsage] = useState('');
    const [unit, setUnit] = useState('');
    const [meterid, setMeterid] = useState('');
    const [status, setStatus] = useState('');
    const [accountname, setAccountname] = useState('');
    const [name, setName] = useState('');
    const [address, setAddress] = useState('');
    const [addressone, setAddressone] = useState('');
    const [addresstwo, setAddresstwo] = useState('');
    const [addressthree, setAddressthree] = useState('');
    const [addressfour, setAddressfour] = useState('');
    const [meterids, setMeterids] = useState('');
    const [statuss, setStatuss] = useState('');
    const [accountnames, setAccountnames] = useState('');
    const [addresss, setAddresss] = useState('');
    const [addressones, setAddressones] = useState('');
    const [addresstwos, setAddresstwos] = useState('');
    const [addressthrees, setAddressthrees] = useState('');
    const [addressfours, setAddressfours] = useState('');
    const [statustext, setStatustext] = useState('');
    const [loading, setLoading] = useState(true);
    const [open, setOpen] = useState(false);
    const [opens, setOpens] = useState(false);
    const [openss, setOpenss] = useState(false);
    const [first,setFirst] = useState(false);
    const [datas, setDatas] = useState([]);
    const [datass, setDatass] = useState([]);
    const [res, setRes] = useState([]);
    const [nerge, setNerge] = useState([null]);
    const [weekly, setWeekly] = useState(false);
    // let history = useHistory();
    const navigate = useNavigate();
    const arryDatass = [];

    const onRedirection = (event) => {

        // history.push('/dashboard');
        // window.history.back();
        navigate(-1);
    }

    const modalclickss = (event) => {
        

        setLoading(true);
        setOpenss(true);
        setName(event.currentTarget.id);
        get(`apis/schematic_meter?total_flow=${event.currentTarget.id}`)


            .then((res) => {

                console.log(res.data.data);
                setRes(res.data.data);
                setAccountname(res.data.data.data_meters[0].account_name);
                setUsage(res.data.data.meter_total_converted);
                setUnit(res.data.data.unit);
                setMeterid(res.data.data.data_meters[0].meter_id);
                setStatus(res?.data?.data?.data_meters[0]?.status);
                setAddress(res.data.data.data_meters[0].location[0].location_address_line1);
                setAddressone(res.data.data.data_meters[0].location[0].location_address_line2);
                setAddresstwo(res.data.data.data_meters[0].location[0].location_city);
                setAddressthree(res.data.data.data_meters[0].location[0].location_state);
                setAddressfour(res.data.data.data_meters[0].location[0].location_zip);
                setAccountnames(res.data.data.data_meters[1].account_name);
                setMeterids(res.data.data.data_meters[1].meter_id);
                setStatuss(res?.data?.data?.data_meters[1]?.status);
                setAddresss(res.data.data.data_meters[1].location[0].location_address_line1);
                setAddressones(res.data.data.data_meters[1].location[0].location_address_line2);
                setAddresstwos(res.data.data.data_meters[1].location[0].location_city);
                setAddressthrees(res.data.data.data_meters[1].location[0].location_state);
                setAddressfours(res.data.data.data_meters[1].location[0].location_zip);
                
                res.data.data.meter_flow.map((x, i) => {
                    console.log(x);

                    let Obj = {
                        name: x[0]?.option,

                        Days: x[0]?.flow,


                    };

                    arryDatass.push(Obj);

                    console.log("arryDatass", arryDatass);



                });
                setNerge(arryDatass);

                console.log("nerge", nerge);

                setLoading(false);
            });
    }
    const weeklyChange = (e) => {
      
        var id=e.target.id;
        setWeekly(e.target.checked);
        var user = JSON.parse(localStorage.getItem("MCData"));
        var userid = user?.userid;
        post(`apis/notification_meters_update?user_id=${userid}&meter_id=${id}&account_name=${accountname}&status=${e.target.checked}`).then(
            (response) => {
                // setdata(response.data.data);

                // toast.success('Added Audit Report Settings Successfully', {
                //     autoClose: 3000,
                // });

            }
        );
    };
    
   
    const modalclicks = (event) => {

        setLoading(true);
        setOpens(true);
        setName(event.currentTarget.id);
        get(`apis/schematic_meter?total_flow=${event.currentTarget.id}`)


            .then((res) => {

                // console.log(res.data.data.meter_flow);
                setRes(res?.data?.data);

                setUsage(res?.data?.data?.meter_total_converted);
                setUnit(res?.data?.data?.unit);

                res.data.data.meter_flow.map((x, i) => {
                    console.log(x);

                    let Obj = {
                        name: x[0]?.option,

                        Days: x[0]?.flow,


                    };

                    arryDatass.push(Obj);

                    console.log("arryDatass", arryDatass);



                });
                setNerge(arryDatass);

                console.log("nerge", nerge);

                setLoading(false);
            });
    }

    const modalclick = (event) => {

        setLoading(true);
        setOpen(true);
        // datass.forEach((x) => {console.log(x.meter_active);
        //     if(x.meter_id==event.currentTarget.id)
        //     {
        //         setWeekly(x.meter_active);
        //     }
           
        //   });
        // {datass?.map((person, index) => (
           
        //     console.log(person)))}
            var user = JSON.parse(localStorage.getItem("MCData"));
            var userid = user?.userid;
        get(`apis/schematic_meter?meter_id=${event.currentTarget.id}&user_id=${userid}`)


            .then((res) => {

                console.log(res.data.data.location[0]);
                setRes(res.data.data);
                setAccountname(res.data.data.account_name);
                setUsage(res.data.data.meter_total_converted);
                setUnit(res.data.data.unit);
                setMeterid(res.data.data.meter_id);
                setStatus(res.data.data.status);
                setAddress(res.data.data.location[0].location_address_line1);
                setAddressone(res.data.data.location[0].location_address_line2);
                setAddresstwo(res.data.data.location[0].location_city);
                setAddressthree(res.data.data.location[0].location_state);
                setAddressfour(res.data.data.location[0].location_zip);
                setWeekly(res.data.data.meter_notification_active.notification_status);
                
                res.data.data.meter_flow.map((x, i) => {
                    console.log(x);

                    let Obj = {
                        name: x?.option,

                        Days: x?.flow,


                    };

                    arryDatass.push(Obj);

                    console.log("arryDatass", arryDatass);



                });
                setNerge(arryDatass);

                console.log("nerge", nerge);

                setLoading(false);
            });
    }
    const handleCancel = () => {

        setOpen(false);
    };
    const handleCancels = () => {

        setOpens(false);
    };
    const handleCancelss = () => {

        setOpenss(false);
    };
    const handleOk = () => {

    };
    const onselectClickss = () => {
        navigate('/schematics');

    }
    const onselectClick = () => {
        navigate('/stats');

    }
    const onselectClicks = () => {
        navigate('/devices');

    }
    // useEffect(() => {
    //     var user = JSON.parse(localStorage.getItem("MCData"));
    //     var userid = user?.userid;
    //     if (first === false)
    //         get(`apis/notification_meters_list?user_id=${userid}`).then(
    //             (response) => {
    //                 setDatass(response.data.data);
    //                 console.log("sssss",response.data.data.data);
    //                 setFirst(true);
    //             }
    //         );
    // }, [first]
    // )

    return (
        <>
            {/* <head>
                <title> {window.location.href.indexOf("mizuwatch.com") > -1?"MizuWatch":"MizuSmart"} </title></head> */}
            <Header />
            <Main className="bg-white">
                <div>
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex fs-30 gap-3">
                            <ArrowLeftOutlined onClick={onRedirection} />
                            <h3 className="my-4">Schematic</h3>
                        </div>

                        <div className="fs-20 fw-bold d-flex gap-3">
                            <div className="px-3 py-1 bg-white ph-meter-stats border text-blue border-info rounded align-self-center c-pointer" onClick={onselectClickss}><BranchesOutlined />Schematic </div>
                            <div className="px-3 py-1 bg-white border rounded align-self-center c-pointer ph-meter-stats" onClick={onselectClick}><BarChartOutlined />Stats </div>
                            <div className="px-3 py-1 bg-white border rounded align-self-center c-pointer ph-meter-stats" onClick={onselectClicks}>
                                <DashboardOutlined title="Meter" /> Meters</div>

                        </div>
                    </div>
                    {openss === true ?
                        <Modal
                            width={800}
                            title=""
                            open={openss}
                            onOk={handleOk}


                            onCancel={handleCancelss}
                            centered="true" className="selectCheckbox">
                            {loading ? <Spin /> : <>
                                <br />
                                <div className="d-flex justify-content-between align-items-center  px-0">
                                    <div className="px-0 fs-4">
                                        <h5 className="text-blue mb-0"> {name==="Produced"?"Total Produced":"Non Potable Supply"}</h5>
                                        <p className="">[Last 30 Days]</p>
                                    </div>
                                    <div>
                                        <h5 className="mb-0 font-weight-100"> {usage}  </h5>
                                        <p className="txt-gallonNew"> {unit}</p>
                                    </div>
                                </div>
                                <LineChart
                                    width={765}
                                    height={300}
                                    data={nerge}
                                    margin={{
                                        top: 5,
                                        right: 30,
                                        left: 20,
                                        bottom: 5,
                                    }}
                                >
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="name" />
                                    <YAxis />
                                    <Tooltip />
                                    <Legend />
                                    <Line type="monotone" dataKey="Days" stroke="#8884d8" activeDot={{ r: 8 }} strokeWidth={2} />

                                </LineChart>
                                <div className='labelYAxis5'>Gallons</div>
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="text-black px-1 included-outliers bg-gray">Meter ID<div className="float-right">{meterid}</div></div>
                                        <div className="row mt-2 fs-20 checkboxGreen">
                                            <div className="divnew">
                                                <h5 className="my-1">Status</h5>
                                                {res?.data_meters[0]?.status?.length == 0 ? <span class="badge bg-success rounded-0">Good</span> : ""}
                                                {res?.data_meters[0]?.status?.map((item, index) => (
                                                    <>
                                                     {
                                                        // item.toLowerCase().includes('leak detected') ?
                                                        res.data_meters[0].impact<=.2?<>
                                                        <span class="yellownoti rounded-0">{res?.data_meters[0]?.status[index]}</span><br/></>
                                                            
                                                            :
                                                            res.data_meters[0].impact<=.4 &&  res.data_meters[0].impact>.2 ?<>
                                                            <span class="orangenoti rounded-0">{res?.data_meters[0]?.status[index]}</span><br /></>
                                                            :
                                                            <><span class="rednoti rounded-0">{res?.data_meters[0]?.status[index]}</span><br /></>
                                                    }</>
                                                    
                                                    // <>
                                                    //     <span class="badge bg-warning rounded-0">{res?.data_meters[0]?.status[index]}</span><br />
                                                    // </>

                                                ))}


                                            </div>
                                        </div>
                                        <div className="text-black px-1 my-2 included-outliers  bg-gray d-flex justify-content-between"><div>Account Name </div><div className="popupalignment"> {accountname}</div></div>
                                        <div className="text-black px-1 included-outliers bg-gray">Location Address</div>
                                        <div>
                                            <div className="my-2 ">{address}<br />
                                                {addressone}<br />
                                                {addresstwo}<br />
                                                {addressthree}<br />
                                                {addressfour}</div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="text-black px-1 included-outliers bg-gray">Meter ID<div className="float-right">{meterids}</div></div>
                                        <div className="row mt-2 fs-20 checkboxGreen">
                                            <div className="divnew">
                                                <h5 className="my-1">Status</h5>
                                                {res?.data_meters[1]?.status?.length == 0 ? <><span class="badge bg-success rounded-0">Good</span>

                                                </> : ""}
                                                {res?.data_meters[1]?.status?.map((item, index) => (
                                                    <>
                                                     {
                                                        // item.toLowerCase().includes('leak detected') ?
                                                        res.data_meters[1].impact<=.2?<>
                                                        <span class="yellownoti  rounded-0">{res?.data_meters[1]?.status[index]}</span><br/></>
                                                            
                                                            :
                                                            res.data_meters[1].impact<=.4 &&  res.data_meters[1].impact>.2 ?<>
                                                            <span class="orangenoti rounded-0">{res?.data_meters[1]?.status[index]}</span><br /></>
                                                            :
                                                            <><span class="rednoti rounded-0">{res?.data_meters[1]?.status[index]}</span><br /></>
                                                    }
                                                        {/* <span class="badge bg-warning rounded-0">{res?.data_meters[1]?.status[index]}</span><br /> */}
                                                    </>

                                                ))}


                                            </div>
                                        </div>
                                        <div className="text-black px-1 my-2 included-outliers  bg-gray d-flex justify-content-between"> <div>Account Name</div> <div className="popupalignment"> {accountnames}</div></div>
                                        <div className="text-black px-1 included-outliers bg-gray">Location Address</div>
                                        <div>
                                            <div className="my-2 ">{addresss}<br />
                                                {addressones}<br />
                                                {addresstwos}<br />
                                                {addressthrees}<br />
                                                {addressfours}</div>
                                        </div>
                                    </div>
                                </div>
                            </>}

                        </Modal>
                        : ""}
                    {open === true ?
                        <Modal
                            width={800}
                            title=""
                            open={open}
                            onOk={handleOk}


                            onCancel={handleCancel}
                            centered="true" className="selectCheckbox">
                            {loading ? <Spin /> : <>
                                <br />
                                <div className="d-flex justify-content-between align-items-center  px-0">
                                    <div className="px-0 fs-4">
                                    {/* <Checkbox ><p><font color="FFA500">Add {meterid} meter to alert</font></p></Checkbox> */}
                                        <h5 className="text-blue mb-0"> Meter Usage </h5>
                                        <p className="">[Last 30 Days]</p>
                                    </div>
                                    <div>
                                        <h5 className="mb-0 font-weight-100"> {usage}  </h5>
                                        <p className="txt-gallonNew"> {unit}</p>
                                    </div>
                                </div>
                                <LineChart
                                    width={765}
                                    height={300}
                                    data={nerge}
                                    margin={{
                                        top: 5,
                                        right: 30,
                                        left: 20,
                                        bottom: 5,
                                    }}
                                >
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="name" />
                                    <YAxis />
                                    <Tooltip />
                                    <Legend />
                                    <Line type="monotone" dataKey="Days" stroke="#8884d8" activeDot={{ r: 8 }} strokeWidth={2} />

                                </LineChart>
                                <div className='labelYAxis5'>Gallons</div>
                               
                                
                                <div className="col text-black px-1 included-outliers bg-gray">Meter ID<div className="float-right">{meterid}</div><br/>
                                <Checkbox id={meterid} onChange={weeklyChange} checked={weekly}><p className="mb-0"><font>Add to alert</font> </p></Checkbox>
                                </div>
                              
                                
                                <div className="row mt-2 fs-20 checkboxGreen">
                                    <div className="divnew">
                                        <h5 className="my-1 px-1">Status</h5>
                                        {res.status.length == 0 ? <><span class="badge bg-success rounded-0">Good</span>

                                        </> : ""}
                                        {res.status.map((item, index) => (
                                            <>
                                             {
                                                        // item.toLowerCase().includes('leak detected') ?
                                                        res.impact<=.2?<>
                                                        <span class="yellownoti rounded-0">{res?.status[index]}</span><br/></>
                                                            
                                                            :
                                                            res.impact<=.4 &&  res.impact>.2 ?<>
                                                            <span class="orangenoti rounded-0">{res?.status[index]}</span><br /></>
                                                            :
                                                            <><span class="rednoti rounded-0">{res?.status[index]}</span><br /></>
                                                    }
                                                {/* <span class="badge bg-warning rounded-0">{res?.status[index]}</span><br /> */}
                                            </>

                                        ))}


                                    </div>
                                </div>
                                <div className="text-black px-0 my-2 included-outliers bg-gray px-1">Account Name <div className="float-right popupalignment"> <div>{accountname}</div></div></div>
                                <div className="text-black px-0 included-outliers bg-gray px-1">Location Address</div>
                                <div>
                                    <div className="my-2 px-1">{address}<br />
                                        {addressone}<br />
                                        {addresstwo}<br />
                                        {addressthree}<br />
                                        {addressfour}</div>
                                </div></>}

                        </Modal>
                        : ""}
                    {opens === true ?
                        <Modal
                            width={800}
                            title=""
                            open={opens}
                            onOk={handleOk}


                            onCancel={handleCancels}
                            centered="true" className="selectCheckbox">
                            {loading ? <Spin /> : <>
                                <br />
                                <div className="d-flex justify-content-between align-items-center  px-0">
                                    <div className="px-0 fs-4">
                                        <h5 className="text-blue mb-0"> {name==="Potable_Demand"?"Consumer Potable Meters":name==="PS"?"Potable Supply":name==="NPS"?"Non Potable Supply":"Consumer Non-Potable Meters"}</h5>
                                        <p className="">[Last 30 Days]</p>
                                    </div>
                                    <div>
                                        <h5 className="mb-0 font-weight-100"> {usage}  </h5>
                                        <p className="txt-gallonNew"> {unit}</p>
                                    </div>
                                </div>
                                <LineChart
                                    width={765}
                                    height={300}
                                    data={nerge}
                                    margin={{
                                        top: 5,
                                        right: 30,
                                        left: 20,
                                        bottom: 5,
                                    }}
                                >
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="name" />
                                    <YAxis />
                                    <Tooltip />
                                    <Legend />
                                    <Line type="monotone" dataKey="Days" stroke="#8884d8" activeDot={{ r: 8 }} strokeWidth={2} />

                                </LineChart>
                                <div className='labelYAxis6'>Gallons</div>

                            </>}

                        </Modal>
                        : ""}
                    <div className="bottom-layout">
                        <div className="container-fluid pb-4 px-0 flex-column">
                            <div className="col-lg-12">
                            <div id="wrapper">
                               <div id="container">
                               <ol className="organizational-chart">
                                    <li className="line-one" >
                                        <div className="line-one-box-one" id="101893" onClick={modalclick} >
                                        <img src={Meter} className="img-fluid" />
                                            <span className="meter-value">101893</span>
                                        </div>
                                        <div className="arrow-first">
                                        <img src={LeftArrow} className="img-fluid img-rotate" />
                                        </div>
                                        <div className="line-one-box-two">
                                        <img src={Tank} className="img-fluid" />
                                            <span className="tank-name">Tank
                                            </span>
                                        </div>
                                        <div className="arrow-sec">
                                        <img src={LeftArrow} className="img-fluid tank-img-arrow" />
                                        </div>
                                        <div className="line-one-box-three" id="17160335" onClick={modalclick}>
                                        <img src={Meter} className="img-fluid" />
                                            <span className="meter-value" >17160335</span>
                                        </div>
                                        <div className="line-one-box-four">
                                            <h1>COH</h1>
                                        </div>
                                    </li>
                                    <li className="line-two">
                                        <div className="line-two-box-one">
                                        <img src={GPWell} className="img-fluid" />
                                            <span className="gp-name">GP Well</span>
                                        </div>
                                        <div className="line-two-box-two">
                                        <div className="arrow-tank">
                                                <img src={LeftArrow} className="img-fluid tank-img-arrow" />
                                                </div>
                                        <img src={WaterPlants} className="img-fluid" />
                                            <p className="line-water-plants">Water Plant</p>
                                        </div>
                                    </li>
                                    <li className="line-three">
                                    <p>North Distribution Meter</p>
                                    <div className="line-three-box-one" id="95434" onClick={modalclick}>
                                    <img src={Meter} className="img-fluid" />
                                        <span className="meter-value">95434</span>
                                    </div>
                                    <div className="line-three-box-two" id="Produced"  onClick={modalclickss}>
                                        <div className="line-small-box-one produced-img" >
                                        <img src={WaterMeter} className="img-fluid" />
                                        </div>
                                        <span className="">Total Produced</span>
                                    </div>
                                    <div className="line-three-box-one" id="126171" onClick={modalclick}>
                                    <img src={Meter} className="img-fluid" />
                                        <span className="meter-value">126171</span>
                                    </div>
                                    <p>South Distribution Meter</p>
                                </li>
                                <li className="line-four">
                                    {/* <div className="line-four-dflex">
                                    <div className="line-four-arrow-first">
                                    <img src={LeftArrow} className="img-fluid tank-img-arrow" />
                                    </div>
                                    </div> */}
                                    {/* <div className="line-four-dflex">
                                    <div className="line-four-arrow-first-img">
                                    <img src={LeftArrow} className="img-fluid tank-img-arrow" />
                                    </div>
                                    </div> */}
                                </li>
                                <li className="new-line-five">
                                    <div className="four-new-line">
                                        <div className="line-four-dflex">
                                            <p>IC</p>
                                            <div className="line-four-box-one" id="150850" onClick={modalclick}>
                                            <img src={Meter} className="img-fluid" />
                                                <span className="meter-value">150850</span>
                                                    <div className="line-four-arrow-down">
                                                    <img src={LeftArrow} className="img-fluid tank-img-arrow" />
                                                    </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="four-new-line box-two-align new-schematics-liness">
                                        <div className="line-four-dflex">
                                            <p>IC</p>
                                            <div className="line-four-box-one" id="150849" onClick={modalclick}>
                                            <img src={Meter} className="img-fluid" />
                                                <span className="meter-value">150849</span>
                                                <div className="line-four-arrow-down">
                                                    <img src={LeftArrow} className="img-fluid tank-img-arrow" />
                                                    </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="four-new-line box-three-align new-schematics-page">
                                        <div className="line-five-box-two" id="PS" onClick={modalclicks}>
                                            <div className="line-small-box-one water-meter-img">
                                            <img src={WaterMeter} className="img-fluid" />
                                            </div>
                                            <span className="">Potable Supply</span>
                                        </div>
                                        <div className="line-five-box-two down-supply" id="Potable_Demand" onClick={modalclicks}>
                                            <div className="line-five-arrow-first-img">
                                            <img src={LeftArrow} className="img-fluid down-new-arrow" />
                                            </div>
                                            <div className="line-small-box-one water-meter-img">
                                            <img src={WaterMeter} className="img-fluid" />
                                            </div>
                                            <span className="">Consumer Potable Meters</span>
                                        </div>
                                    </div>
                                    <div className=" four-new-line-end schematice-new-style">
                                        <div className="d-flex align-items-baseline">
                                        {/*  */}
                                        <div className="line-five-box-one margin-15 left-line" id="114476" onClick={modalclick}>
                                        <img src={Meter} className="img-fluid" />
                                            <span className="meter-value">114476</span>
                                        </div>
                                        <div className="line-five-box-one margin-15 line-border middile-space" id="114477" onClick={modalclick}>
                                        <img src={Meter} className="img-fluid" />
                                            <span className="meter-value">114477</span>
                                        </div>
                                        
                                        <div className="line-five-box-one margin-15 line-border"  id="129122" onClick={modalclick}>
                                        <img src={Meter} className="img-fluid" />
                                            <span className="meter-value">129122</span>
                                        </div>
                                        <div className="line-five-box-one left-line-2"  id="129123" onClick={modalclick}>
                                        <img src={Meter} className="img-fluid" />
                                            <span className="meter-value">129123</span>
                                        </div>
                                        </div>
                                        {/*  */}
                                        <div className="line-five-box-two scheme-new-five-box">
                                            <div className="line-small-box-one water-meter-img consumer-img five-bg">
                                            <img src={WaterMeter} className="img-fluid" id="NPS" onClick={modalclicks}/>
                                            </div>
                                            <span className="" id="NPS" onClick={modalclicks}>Non Potable Supply</span>
                                            
                                            <div className="line-five-box-two down-supply" >
                                            <div className="line-five-arrow-first-img">
                                            <img src={LeftArrow} className="img-fluid down-new-arrow-sec new-schem-img" />
                                            </div>
                                            <div className="line-small-box-one water-meter-img water-size-adjust">
                                            <img src={WaterMeter} className="img-fluid" id="Non_Potable_Demand" onClick={modalclicks}/>
                                            </div>
                                            <span className="" id="Non_Potable_Demand" onClick={modalclicks}>Consumer Non-Potable Meters</span>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </li>
                                {/* <li className="line-five">
                                <div className="line-five-box-one" id="114477" onClick={modalclick}>
                                <img src={Meter} className="img-fluid" />
                                    <span className="meter-value">114477</span>
                                </div>
                                <div className="line-five-box-two" id="NPS" onClick={modalclickss}>
                                    <div className="line-small-box-one water-meter-img">
                                    <img src={WaterMeter} className="img-fluid" />
                                    </div>
                                    <span className="">Non-Potable Supply</span>
                                </div>
                                <div className="line-five-box-one"  id="129122" onClick={modalclick}>
                                <img src={Meter} className="img-fluid" />
                                    <span className="meter-value">129122</span>
                                </div>
                            </li> */}
                            {/* <li className="line-six">
                                <div className="line-six-box-two" id="Non_Potable_Demand" onClick={modalclicks}>
                                    <div className="line-six-arrow-first">
                                    <img src={LeftArrow} className="img-fluid tank-img-arrow" />
                                    </div>
                                    <div className="line-six-small-box-one" >
                                    <img src={WaterMeter} className="img-fluid" />
                                    </div>
                                    <span className="">To Consumer Non-Potable Meters</span>
                                </div>
                            </li> */}
                            {/* <li className="line-seven">
                                <div className="line-seven-box-two" id="Potable_Demand" onClick={modalclicks}>
                                    <div className="line-six-arrow-first">
                                    <img src={LeftArrow} className="img-fluid tank-img-arrow" />
                                    </div>
                                    <div className="line-seven-small-box-one" >
                                    <img src={WaterMeter} className="img-fluid" />
                                    </div>
                                    <span className="">Consumer Potable Meters</span>
                                </div>
                            </li> */}
                                </ol>
                                </div>    
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Main>

        </>);
};
export default Schematics;